import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx } from 'react/jsx-runtime';
import React__default, { useMemo } from 'react';
import * as RadixAccordion from '@radix-ui/react-accordion';
import accordionStyles from './Accordion.styles.esm.js';
import { AccordionContent } from './AccordionContent.esm.js';
import { AccordionContext } from './AccordionContext.esm.js';
import { AccordionItem } from './AccordionItem.esm.js';
import { AccordionTrigger } from './AccordionTrigger.esm.js';
import { cn } from '../../utils/cn.esm.js';

/**
 * Create the Accordion component
 */
const AccordionComponent = React__default.forwardRef((props, ref) => {
    const { className, variant = "contained", inverse = false, showTopDivider, children, additionalLabel } = props, accordionProps = __rest(props, ["className", "variant", "inverse", "showTopDivider", "children", "additionalLabel"]);
    const { root } = useMemo(() => accordionStyles({
        variant,
        inverse,
    }), [variant, inverse]);
    // Create context value
    const contextValue = useMemo(() => ({
        variant,
        inverse,
        additionalLabel,
        showTopDivider,
    }), [variant, inverse, additionalLabel, showTopDivider]);
    return (jsx(AccordionContext.Provider, { value: contextValue, children: jsx(RadixAccordion.Root, Object.assign({ ref: ref, className: cn([root(), className]), type: "multiple" }, accordionProps, { children: children })) }));
});
// Set display names for better debugging
AccordionComponent.displayName = "Accordion";
AccordionItem.displayName = "AccordionItem";
AccordionTrigger.displayName = "AccordionTrigger";
AccordionContent.displayName = "AccordionContent";
const Accordion = AccordionComponent;
// Attach the subcomponents to the main component
Accordion.Item = AccordionItem;
Accordion.Trigger = AccordionTrigger;
Accordion.Content = AccordionContent;

export { Accordion };
